import { render, staticRenderFns } from "./ViewTeachersSchedules.vue?vue&type=template&id=3ba465bb&scoped=true&"
import script from "./ViewTeachersSchedules.vue?vue&type=script&lang=js&"
export * from "./ViewTeachersSchedules.vue?vue&type=script&lang=js&"
import style0 from "./ViewTeachersSchedules.vue?vue&type=style&index=0&id=3ba465bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba465bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
